/* unplugin-vue-components disabled */import { render } from "./AssistantTools.vue?vue&type=template&id=1c190b5e&scoped=true"
import script from "./AssistantTools.vue?vue&type=script&lang=js"
export * from "./AssistantTools.vue?vue&type=script&lang=js"

import "./AssistantTools.vue?vue&type=style&index=0&id=1c190b5e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c190b5e"]])

export default __exports__